<div class="equation-shell"
     [class.eq-top]="isEquationTopOperand()"
     [class.eq-bottom]="isEquationBottomOperand()"
     [class.eq-result]="isEquationResult()"
     [class.eq-def]="getEquationToken() === 'def'"
     [class.eq-lcc]="getEquationToken() === 'lcc'"
     [class.eq-fuel]="getEquationToken() === 'fuel'"
     *ngIf="data">
  <div class="equation-divider" *ngIf="shouldShowDivider()"></div>

      <div class="chart-wrapper"
           [style.zoom]="getChartScale()"
           [style.--chart-offset-x.px]="getChartOffsetXPx()">
    <ng-container *ngIf="!shouldUseSplitChartLayout(); else splitChartLayout">
      <div class="bars-container"
        [style.padding-top.px]="getTopPadding()"
        [style.--bar-gap.px]="getBarGapPx()"
        [style.--bar-width.px]="getBarWidthPx()">
      <div class="bars-track">
        <div class="connector-line"
             *ngIf="shouldShowConnector() && !isFirstBarMode()"
             [style.bottom.px]="getConnectorBottom()"></div>

        <div class="first-bar-overlay" *ngIf="shouldShowConnector() && isFirstBarMode()">
          <div class="first-bar-trunk"
               [class.no-arrow]="!shouldShowConnectorArrow(getBaselineBarIndex())"
               [style.left]="getBaselineAnchorLeft()"
               [style.bottom.px]="getTipBottom(getBaselineBarIndex())"
               [style.height.px]="getFirstBarTrunkHeight()"></div>

          <div class="first-bar-branch"
               *ngFor="let value of values; let i = index"
               [style.display]="i !== getBaselineBarIndex() && hasComparison(i) ? 'block' : 'none'"
               [style.left]="getBaselineAnchorLeft()"
               [style.bottom.px]="getFirstBarBranchBottom(i)"
               [style.width]="getFirstBarBranchWidth(i)">
            <div class="first-bar-line"></div>
            <div class="first-bar-right-stem"
                 [class.no-arrow]="!shouldShowConnectorArrow(i)"
                 [style.height.px]="getFirstBarRightStemHeight(i)"></div>
            <div class="pair-bubble first-bar-bubble"
                 *ngIf="shouldShowComparisonBubbles()"
                 [style.bottom.px]="getFirstBarBubbleBottom(i)">
              {{ formatPercent(getBarComparison(i)!) }}
            </div>
          </div>
        </div>

        <div class="bar-block"
             *ngFor="let value of values; let i = index">

          <div class="bar-tip"
               *ngIf="shouldShowConnector() && !isFirstBarMode() && isRenderableBar(i)"
               [class.no-arrow]="!shouldShowConnectorArrow(i)"
               [style.bottom.px]="getTipBottom(i)"
               [style.height.px]="getTipHeight(i)"></div>

          <div class="pair-bubble"
               *ngIf="shouldShowConnector() && shouldShowComparisonBubbles() && !isFirstBarMode() && hasComparison(i)"
               [style.bottom.px]="getBubbleOnConnectorBottom()">
            {{ formatPercent(getBarComparison(i)!) }}
          </div>

          <div class="pair-bubble top-bubble"
               *ngIf="!shouldShowConnector() && shouldShowComparisonBubbles() && hasComparison(i)">
            {{ formatPercent(getBarComparison(i)!) }}
          </div>

          <div class="value" *ngIf="shouldShowValues() && isRenderableBar(i)">{{ value }}</div>
          <div class="stacked-bar"
               *ngIf="isRenderableBar(i) && hasStackedBar(i)"
               [style.height.px]="getStackedBarHeight(i)"
               [style.animation-delay.ms]="i * 90">
            <div class="stacked-segment"
                 *ngFor="let segment of getRenderableStackSegments(i); let si = index"
                 [style.background]="getStackSegmentColor(i, si)"
                 [style.height.px]="getStackSegmentHeight(i, si)">
              <span class="stacked-segment-label"
                    *ngIf="shouldShowStackSegmentLabel(i, si)">
                {{ getStackSegmentShortLabel(i, si) }}
              </span>
            </div>
          </div>
          <div class="bar"
               *ngIf="isRenderableBar(i) && !hasStackedBar(i)"
               [style.background]="getBarColor(i)"
               [style.height.px]="getBarHeight(value)"
               [style.animation-delay.ms]="i * 90">
          </div>
          <div class="raw-values-tooltip"
               *ngIf="shouldShowRawValueTooltip()"
               [class.tooltip-align-left]="i === 0"
               [class.tooltip-align-right]="i === values.length - 1">
            <div class="raw-values-tooltip-row" *ngFor="let item of getRawValueTooltipItems(i)">
              {{ item.label }}: {{ item.value }}
            </div>
          </div>
          <div class="label" *ngIf="shouldShowLabels()">{{ labels[i] }}</div>
          <div class="no-breakdown-note" *ngIf="shouldShowLabels() && hasNoBreakdown(labels[i])">CPH contract</div>
        </div>
      </div>
    </div>
    </ng-container>

    <ng-template #splitChartLayout>
      <div class="split-charts-container"
           [style.gap.px]="getSplitChartGapPx()">
        <div class="split-chart"
             *ngFor="let chart of splitComparisonCharts"
             [attr.data-chart-key]="chart.key">
          <div class="bars-container split-bars-container"
               [style.padding-top.px]="getSplitChartTopPadding(chart)"
               [style.--bar-gap.px]="getSplitBarGapPx()"
               [style.--bar-width.px]="getSplitBarWidthPx()">
            <div class="bars-track">
              <div class="connector-line"
                   *ngIf="shouldShowSplitChartConnector(chart) && !isFirstBarMode()"
                   [style.bottom.px]="getSplitChartConnectorBottom(chart)"></div>

              <div class="first-bar-overlay" *ngIf="shouldShowSplitChartConnector(chart) && isFirstBarMode()">
                <div class="first-bar-trunk"
                     [class.no-arrow]="!shouldShowSplitChartConnectorArrow(chart, getSplitChartBaselineIndex(chart))"
                     [style.left]="getSplitChartBaselineAnchorLeft(chart)"
                     [style.bottom.px]="getSplitChartTipBottom(chart, getSplitChartBaselineIndex(chart))"
                     [style.height.px]="getSplitChartFirstBarTrunkHeight(chart)"></div>

                <div class="first-bar-branch"
                     *ngFor="let value of chart.values; let i = index"
                     [style.display]="i !== getSplitChartBaselineIndex(chart) && hasSplitChartComparison(chart, i) ? 'block' : 'none'"
                     [style.left]="getSplitChartBaselineAnchorLeft(chart)"
                     [style.bottom.px]="getSplitChartFirstBarBranchBottom(chart, i)"
                     [style.width]="getSplitChartFirstBarBranchWidth(chart, i)">
                  <div class="first-bar-line"></div>
                  <div class="first-bar-right-stem"
                       [class.no-arrow]="!shouldShowSplitChartConnectorArrow(chart, i)"
                       [style.height.px]="getSplitChartFirstBarRightStemHeight(chart, i)"></div>
                  <div class="pair-bubble first-bar-bubble"
                       *ngIf="shouldShowComparisonBubbles()"
                       [style.bottom.px]="getSplitChartFirstBarBubbleBottom()">
                    {{ formatPercent(getSplitChartComparison(chart, i)!) }}
                  </div>
                </div>
              </div>

              <div class="bar-block"
                   *ngFor="let value of chart.values; let i = index">

                <div class="bar-tip"
                     *ngIf="shouldShowSplitChartConnector(chart) && !isFirstBarMode() && isSplitChartRenderableBar(chart, i)"
                     [class.no-arrow]="!shouldShowSplitChartConnectorArrow(chart, i)"
                     [style.bottom.px]="getSplitChartTipBottom(chart, i)"
                     [style.height.px]="getSplitChartTipHeight(chart, i)"></div>

                <div class="pair-bubble"
                     *ngIf="shouldShowSplitChartConnector(chart) && shouldShowComparisonBubbles() && !isFirstBarMode() && hasSplitChartComparison(chart, i)"
                     [style.bottom.px]="getSplitChartBubbleOnConnectorBottom(chart)">
                  {{ formatPercent(getSplitChartComparison(chart, i)!) }}
                </div>
                <div class="pair-bubble top-bubble"
                     *ngIf="!shouldShowSplitChartConnector(chart) && shouldShowComparisonBubbles() && hasSplitChartComparison(chart, i)">
                  {{ formatPercent(getSplitChartComparison(chart, i)!) }}
                </div>

                <div class="value" *ngIf="shouldShowValues() && isSplitChartRenderableBar(chart, i)">{{ value }}</div>
                <div class="bar"
                     *ngIf="isSplitChartRenderableBar(chart, i)"
                     [style.background]="getSplitChartBarColor(chart, i)"
                     [style.height.px]="getSplitChartBarHeight(chart, value)"
                     [style.animation-delay.ms]="i * 90">
                </div>
                <div class="raw-values-tooltip"
                     *ngIf="shouldShowRawValueTooltip()"
                     [class.tooltip-align-left]="i === 0"
                     [class.tooltip-align-right]="i === chart.values.length - 1">
                  <div class="raw-values-tooltip-row" *ngFor="let item of getSplitRawValueTooltipItems(chart, i)">
                    {{ item.label }}: {{ item.value }}
                  </div>
                </div>
                <div class="label" *ngIf="shouldShowLabels()">{{ getSplitChartLabel(chart, i) }}</div>
              </div>
            </div>
          </div>
          <div class="split-chart-title split-chart-title-bottom">{{ chart.label }}</div>
        </div>
      </div>
    </ng-template>

    <div class="axis-label" *ngIf="getBottomLabel()">{{ getBottomLabel() }}</div>
    <div class="chart-note" *ngIf="shouldShowNoBreakdownChartNote()">
      CPH contract, hence LCC breakdown not available.
    </div>
  </div>

  <div class="equation-op plus" *ngIf="shouldShowPlus()">+</div>
  <div class="equation-op equals" *ngIf="shouldShowEquals()">=</div>
</div>
